import { useIsLoggedIn, useUserStore } from '@ekonavi/base-test';

import { cn } from '@/lib/utils';
import { HeaderActionButton } from './header-action-button';
import { useHeaderEffects } from './header-effects';
import { useResolveNavigate } from '../../hooks/use-resolve-navigate';

export function Header() {
	const { user } = useUserStore();
	const isLoggedIn = useIsLoggedIn();
	const resolveNavigate = useResolveNavigate();

	const iconSize = '80px';

	useHeaderEffects();

	return (
		<div className={`fixed grid grid-rows w-full top-0    bg-[var(--background)]  h-[var(--header-height)] z-[99] leve-border-bottom-light `}>
			<div className={`leve-border-bottom-dark p-2`}>
				<div className='max-w-6xl mx-auto w-full px-6'>
					<div className='  grid grid-cols-3  h-12'>
						<span
							onClick={() => resolveNavigate({ path: '/' })}
							className='text-4xl font-extrabold transition-colors hover:opacity-70 pt-2 cursor-pointer w-[100px]'>
							FAZ
						</span>

						<div className={` flex flex-col items-center justify-center pt-2`}>
							<img
								onClick={() => resolveNavigate({ path: '/painel' })}
								src='/EKONAVI-logo-icon.svg'
								alt='logo'
								style={{ width: iconSize, height: iconSize }}
								className={cn('cursor-pointer rounded-full bg-white/50 shadow-md', isLoggedIn && 'fixed bottom-6 z-[9999] right-0 left-0  mx-auto border-black/10 border ')}
							/>
						</div>

						<div className={`flex flex-row justify-end pt-2`}>
							<HeaderActionButton />
						</div>
					</div>
					<div className={` w-full `}>{user.username || user.email || `Bem-vindo`}</div>
				</div>
			</div>
		</div>
	);
}
